import { useState, useCallback } from 'react'

export const useProfile = () => {
  const [profileDialogOpen, setProfileDialogOpen] = useState(false)
  const [selectedMemberId, setSelectedMemberId] = useState<string | null>(null)
  /** The tab the profile opens on (`achievements` from the "you got a badge" link); absent = the first. */
  const [initialTab, setInitialTab] = useState<string | undefined>(undefined)

  const openProfile = useCallback((memberId: string, tab?: string) => {
    setSelectedMemberId(memberId)
    setInitialTab(tab)
    setProfileDialogOpen(true)
  }, [])

  const closeProfile = useCallback(() => {
    setProfileDialogOpen(false)
    setSelectedMemberId(null)
    setInitialTab(undefined)
  }, [])

  return {
    profileDialogOpen,
    selectedMemberId,
    initialTab,
    openProfile,
    closeProfile
  }
}
